// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CB-CONNECT - BNCB Togo - Design System
   Charte graphique institutionnelle CEDEAO
   Règle 60/30/10 : 60% fonds clairs / 30% vert / 10% or
   ============================================================ */

:root {
  /* ── Vert institutionnel (PRIMARY) ── */
  --cb-green:        #1a6b3c;
  --cb-green-dark:   #155731;
  --cb-green-mid:    #28804e;
  --cb-green-light:  #3da068;
  --cb-green-pale:   #e8f5ed;
  --cb-green-xpale:  #f0faf4;

  /* ── Marron terre (SECONDARY) ── */
  --cb-brown:        #9b563a;
  --cb-brown-light:  #b36b4d;
  --cb-brown-pale:   #f5ede8;

  /* ── Or africain (ACCENT – max 10%) ── */
  --cb-gold:         #d5c93b;
  --cb-gold-dark:    #c4b935;
  --cb-gold-pale:    #fdfce8;

  /* ── Surfaces & fonds ── */
  --cb-bg:           #f8f9fb;
  --cb-card:         #ffffff;
  --cb-surface:      #f4f6f5;
  --cb-white:        #ffffff;

  /* ── Texte ── */
  --cb-text:         #111827;
  --cb-text-sec:     #374151;
  --cb-text-muted:   #6b7280;
  --cb-text-light:   #9ca3af;

  /* ── Bordures ── */
  --cb-border:       #e5e7eb;
  --cb-border-light: #f3f4f6;

  /* ── Sidebar ── */
  --cb-sidebar-bg:   #1a6b3c;
  --cb-sidebar-w:    250px;
  --cb-sidebar-w-lg: 250px;
  --cb-sidebar-w-sm: 64px;
  --cb-navbar-bg:    #155731;
  --cb-navbar-h:     56px;

  /* ── Statuts ── */
  --cb-success-bg:   #dcfce7;
  --cb-success-tx:   #166534;
  --cb-warning-bg:   #fef3c7;
  --cb-warning-tx:   #92400e;
  --cb-danger-bg:    #fee2e2;
  --cb-danger-tx:    #991b1b;
  --cb-info-bg:      #dbeafe;
  --cb-info-tx:      #1e40af;

  /* ── Notification ── */
  --cb-notif:        #ef4444;

  /* ── Ombres ── */
  --shadow-sm:  0 1px 3px rgba(0,0,0,0.08);
  --shadow-md:  0 4px 12px rgba(0,0,0,0.10);
  --shadow-lg:  0 10px 28px rgba(0,0,0,0.12);

  /* ── Rayons ── */
  --radius-sm:  6px;
  --radius-md:  10px;
  --radius-lg:  14px;
  --radius-xl:  20px;

  /* ── Typo ── */
  --font-main: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

  /* Police a chasse fixe pour ce qui est VRAIMENT du code : cle d'API, code
     d'habilitation, identifiant technique. Surtout pas pour les montants - un
     \`font-family: monospace\` nu retombe sur Courier ou Liberation Mono selon le
     poste, ce qui donne a une somme en FCFA l'allure d'une sortie de terminal.
     Les chiffres de l'interface restent en DM Sans, alignes par \`tabular-nums\`. */
  --cb-font-mono: ui-monospace, 'SF Mono', 'DM Mono', 'JetBrains Mono', Menlo, Consolas, monospace;

  /* ── Transitions ── */
  --tr-fast: 150ms ease;
  --tr-base: 220ms ease;
  --tr-slow: 350ms ease;
}

/* ── Reset & base ── */
*, *::before, *::after { box-sizing: border-box; }

body {
  margin: 0;
  font-family: var(--font-main);
  font-size: 14px;
  color: var(--cb-text);
  background: var(--cb-bg);
  -webkit-font-smoothing: antialiased;
  /* Chiffres a chasse constante DANS la police de l'interface : les colonnes de
     montants s'alignent verticalement sans recourir a une police de code. C'est
     pose une fois sur body plutot que repete sur chaque cellule. */
  font-variant-numeric: tabular-nums lining-nums;
  font-feature-settings: 'tnum' 1, 'lnum' 1;
}

/* ── Scrollbar personnalisée ── */
::-webkit-scrollbar { width: 5px; height: 5px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 10px; }

/* ── Layout principal ── */
.cb-layout {
  display: flex;
  /* Le bandeau d'environnement decale deja \`body\` : sans le retrancher ici,
     le cadre depasse le viewport de sa hauteur exacte. */
  min-height: calc(100vh - var(--cb-banniere-h, 0px));
}

.cb-main {
  flex: 1 1;
  margin-left: var(--cb-sidebar-w);
  margin-top: var(--cb-navbar-h);
  min-height: calc(100vh - var(--cb-navbar-h) - var(--cb-banniere-h, 0px));
  background: var(--cb-bg);
  transition: margin-left var(--tr-base);
}

.cb-content {
  padding: 28px 32px;
  max-width: 1600px;
}

/* ── Ant Design token overrides ── */
.ant-btn-primary { background: var(--cb-green) !important; border-color: var(--cb-green) !important; }
.ant-btn-primary:hover { background: var(--cb-green-mid) !important; border-color: var(--cb-green-mid) !important; }
.ant-pagination-item-active { border-color: var(--cb-green) !important; }
.ant-pagination-item-active a { color: var(--cb-green) !important; }
.ant-checkbox-checked .ant-checkbox-inner { background-color: var(--cb-green) !important; border-color: var(--cb-green) !important; }
.ant-switch-checked { background: var(--cb-green) !important; }
.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn { color: var(--cb-green) !important; }
.ant-tabs-ink-bar { background: var(--cb-green) !important; }
.ant-menu-item-selected { background-color: var(--cb-green-pale) !important; color: var(--cb-green) !important; }

/* ── Cards CB ── */
.cb-card {
  background: var(--cb-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--cb-border);
  box-shadow: var(--shadow-sm);
  padding: 24px;
}

.cb-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 12px;
}

.cb-card-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--cb-text);
  margin: 0;
}

/* ── Page header ── */
/* En-tete de page a l'impression.
   Le fond vert est une aide a l'ecran : sur papier c'est un aplat de couleur qui
   consomme de l'encre et n'apporte rien. On retire le fond, la bordure et les
   marges, on garde le titre - les etats statistiques s'impriment, et perdre leur
   intitule serait pire que l'imprimer sans decor.
   Les boutons de l'en-tete portent deja \`.no-print\` cote ecran appelant. */
@media print {
  .cb-page-header-card {
    background: transparent !important;
    border-radius: 0 !important;
    padding: 0 0 8px !important;
    margin-bottom: 12px !important;
    border-bottom: 1px solid #d1d5db;
  }
}

.cb-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
  min-width: 0;
}

.cb-page-header > div:first-child {
  min-width: 0;
  flex: 1 1;
}

.cb-page-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--cb-text);
  margin: 0;
}

.cb-page-sub {
  font-size: 13px;
  color: var(--cb-text-muted);
  margin: 4px 0 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

/* ── Badges statut ── */
.cb-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: var(--radius-xl);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.cb-badge-success { background: var(--cb-success-bg); color: var(--cb-success-tx); }
.cb-badge-warning { background: var(--cb-warning-bg); color: var(--cb-warning-tx); }
.cb-badge-danger  { background: var(--cb-danger-bg);  color: var(--cb-danger-tx);  }
.cb-badge-info    { background: var(--cb-info-bg);    color: var(--cb-info-tx);    }
.cb-badge-neutral { background: var(--cb-surface);    color: var(--cb-text-muted); }
.cb-badge-green   { background: var(--cb-green-pale); color: var(--cb-green);      }

/* ── KPI Card ── */
.kpi-card {
  background: var(--cb-card);
  border-radius: var(--radius-lg);
  border: 1px solid var(--cb-border);
  padding: 20px;
  cursor: pointer;
  transition: all var(--tr-base);
  box-shadow: var(--shadow-sm);
}
.kpi-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
  border-color: var(--cb-green);
}
.kpi-card__icon {
  width: 44px; height: 44px;
  border-radius: var(--radius-md);
  display: flex; align-items: center; justify-content: center;
  font-size: 20px; margin-bottom: 14px;
}
.kpi-card__label { font-size: 13px; color: var(--cb-text-muted); margin-bottom: 4px; }
.kpi-card__value { font-size: 28px; font-weight: 700; color: var(--cb-text); line-height: 1; }
.kpi-card__delta { font-size: 12px; margin-top: 6px; }

/* ── Table CB ── */
.cb-table .ant-table { font-size: 13px; }
.cb-table .ant-table-thead > tr > th {
  background: var(--cb-surface) !important;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--cb-text-muted);
  border-bottom: 1px solid var(--cb-border);
  padding: 12px 16px;
}
.cb-table .ant-table-tbody > tr > td { padding: 12px 16px; border-bottom: 1px solid var(--cb-border-light); }
.cb-table .ant-table-tbody > tr:hover > td { background: var(--cb-green-xpale) !important; }
.cb-table .ant-table-tbody > tr:last-child > td { border-bottom: none; }

/* ── Formulaires ── */
.cb-form-section {
  background: var(--cb-card);
  border: 1px solid var(--cb-border);
  border-radius: var(--radius-lg);
  padding: 24px;
  margin-bottom: 20px;
}
.cb-form-section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--cb-green);
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--cb-border);
}

/* ── Alertes délais ── */
/* Sinistres liés : membre le moins avancé du groupe - infobulle sur la ligne
   porte le sens, ce fond n'est qu'un renfort visuel, pas le seul signal. */
.liaison-membre-moins-avance > td { background: #fffbeb !important; }

.delai-critique { border-left: 4px solid var(--cb-notif) !important; }
.delai-urgent   { border-left: 4px solid #f97316 !important; }
.delai-attention{ border-left: 4px solid var(--cb-gold) !important; }
.delai-normal   { border-left: 4px solid var(--cb-green) !important; }

/* ── Loader global ── */
.cb-loader {
  display: flex; align-items: center; justify-content: center;
  min-height: 200px;
}

/* ── Empty state ── */
.cb-empty {
  text-align: center;
  padding: 60px 20px;
  color: var(--cb-text-muted);
}
.cb-empty-icon { font-size: 48px; margin-bottom: 12px; opacity: 0.4; }

/* ── Tabs à entête vert (header de section) ── */
.cb-tabs-green > .ant-tabs-nav {
  background: var(--cb-green);
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  margin: 0;
  padding: 0 12px;
}
.cb-tabs-green > .ant-tabs-nav::before { border-bottom: none !important; }
.cb-tabs-green > .ant-tabs-nav .ant-tabs-tab { color: rgba(255,255,255,0.75); }
.cb-tabs-green > .ant-tabs-nav .ant-tabs-tab:hover { color: #fff; }
.cb-tabs-green > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff !important;
  font-weight: 600;
}
.cb-tabs-green > .ant-tabs-nav .ant-tabs-ink-bar { background: #fff !important; }

/* ── Steps (progress) en vert application ── */
.cb-steps-green .ant-steps-item-process .ant-steps-item-icon {
  background: var(--cb-green);
  border-color: var(--cb-green);
}
.cb-steps-green .ant-steps-item-finish .ant-steps-item-icon {
  border-color: var(--cb-green);
  background: var(--cb-green-pale);
}
.cb-steps-green .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: var(--cb-green);
}
.cb-steps-green .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
  background-color: var(--cb-green);
}
.cb-steps-green .ant-steps-item-process .ant-steps-item-title {
  color: var(--cb-green) !important;
  font-weight: 600;
}

/* ── Ancrage d'une discussion sur une ligne de dossier ──
   La pastille ne s'efface que lorsqu'AUCUN message n'y est attaché : dans ce cas
   elle est une affordance, et une icône permanente sur chaque ligne d'un tableau
   dense ajouterait une colonne de bruit. Dès qu'un message existe, le composant
   retire cette classe et la pastille reste visible - c'est alors une information.
   \`focus-within\` la fait réapparaître au clavier : une affordance qui n'existe
   qu'au survol est une affordance qui n'existe pas pour qui n'utilise pas la souris. */
.cb-ancre-discussion {
  opacity: 0;
  transition: opacity 140ms ease;
}
.ant-table-row:hover .cb-ancre-discussion,
.ant-table-row:focus-within .cb-ancre-discussion,
.cb-ancre-discussion:hover,
.cb-ancre-discussion:focus {
  opacity: 1;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .cb-main { margin-left: 0; }
  .cb-content { padding: 16px; }
  .cb-page-title { font-size: 18px; }

  /* Le rail latéral suppose une largeur d'écran que le mobile n'a pas : la
     discussion y passerait devant le dossier au lieu de l'accompagner. */
  .cb-discussion-rail { display: none; }
}


/* ── Bandeau d'environnement ────────────────────────────────────────────────
   Le bandeau est en \`position: fixed\` : il ne pousse rien tout seul. Ce
   decalage est pose UNE fois sur \`body\` plutot qu'ecran par ecran, car la
   connexion, l'OTP, l'activation et le portail de verification n'utilisent pas
   \`Layout\` et les oublier aurait laisse le bandeau recouvrir leur en-tete.

   CETTE REGLE VIT ICI ET NON DANS index.css : ce dernier n'est importe par
   AUCUN module. La regle y etait donc morte, le contenu restait colle en haut,
   et le fil d'Ariane passait sous la NavBar qu'on venait de descendre.

   \`--cb-banniere-h\` vaut 0px tant que le bandeau n'est pas affiche : sans
   reponse du serveur, rien ne bouge. Les elements en \`position: fixed\` ne sont
   pas concernes par ce padding et portent leur propre \`top\`. */
body {
  padding-top: var(--cb-banniere-h, 0px);
}


/* ── Defilement du texte du bandeau ─────────────────────────────────────────
   Le message defile en continu et le bandeau reste PLEIN : le texte ne doit
   jamais attendre d'avoir fini de sortir pour que le suivant entre.

   Le composant mesure une copie, en pose assez pour couvrir la largeur du
   bandeau plus une, puis expose cette largeur dans \`--cb-copie-w\`. On translate
   d'exactement UNE copie : a la fin du cycle chaque copie occupe la place de sa
   voisine, l'image est identique et le retour a zero invisible.

   LA DUREE VIENT DU COMPOSANT, pas d'ici : elle est calculee a vitesse
   constante (pixels par seconde). Une duree fixe en CSS aurait fait ramper un
   texte court et filer un texte long.

   \`flex: none\` sur les copies : sans lui elles se laisseraient comprimer a la
   largeur du bandeau, la mesure vaudrait autre chose que la largeur reelle du
   texte, et la translation ne retomberait plus juste. */
.cb-banniere-piste {
  display: flex;
  flex: none;
  width: max-content;
  animation-name: cb-banniere-defile;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 30s; /* repli tant que la mesure n'a pas eu lieu */
}

.cb-banniere-texte {
  flex: none;
  white-space: nowrap;
  padding-right: 48px;
}

@keyframes cb-banniere-defile {
  from { transform: translateX(0); }
  to   { transform: translateX(calc(-1 * var(--cb-copie-w, 50%))); }
}

/* Le survol suspend le defilement : un message qui bouge est penible a lire en
   entier, et c'est le geste attendu pour le retenir. */
.cb-banniere-piste:hover {
  animation-play-state: paused;
}

/* MOUVEMENT REDUIT : on ARRETE, on ne ralentit pas. Un bandeau permanent qui
   defile sans fin declenche vertiges et gene chez qui a demande moins de
   mouvement, et ce message est affiche sur tous les ecrans, en permanence.
   Le texte reste alors centre et tronque proprement s'il est trop long, et les
   copies decoratives disparaissent : elles ne servaient qu'au defilement. */
@media (prefers-reduced-motion: reduce) {
  .cb-banniere-piste {
    animation: none;
    width: 100%;
    justify-content: center;
    overflow: hidden;
  }
  .cb-banniere-texte {
    flex: 0 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 0;
  }
  .cb-banniere-texte[aria-hidden="true"] {
    display: none;
  }
}

/* ── Tiroirs et fenetres sous le bandeau d'environnement ────────────────────
   Le bandeau est en \`position: fixed\` au-dessus de tout (z-index 2000). Les
   tiroirs d'Ant Design occupent le viewport entier depuis \`top: 0\` : leur
   en-tete passait donc DESSOUS et devenait illisible.

   ON DESCEND LE TIROIR PLUTOT QUE D'ABAISSER LE BANDEAU. Le faire passer sous
   le tiroir l'aurait masque pendant une saisie, c'est-a-dire au moment precis
   ou savoir sur quel environnement on travaille importe le plus.

   \`--cb-banniere-h\` vaut 0px quand aucun bandeau n'est affiche : sans bandeau,
   ces regles ne deplacent rien. */
.ant-drawer {
  top: var(--cb-banniere-h, 0px);
  height: calc(100% - var(--cb-banniere-h, 0px));
}

/* Le masque suit le tiroir : laisse en place, il assombrissait le bandeau. */
.ant-drawer .ant-drawer-mask {
  top: 0;
  bottom: 0;
}

/* Meme raison pour les fenetres modales hautes, qui partent du haut du
   viewport et se retrouvaient amputees de leur titre. */
.ant-modal-wrap {
  top: var(--cb-banniere-h, 0px);
}
`, "",{"version":3,"sources":["webpack://./src/theme/variables.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAGjE;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,yCAAyC;EACzC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;;EAE1B,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;;EAEvB,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;;EAE1B,uBAAuB;EACvB,0BAA0B;;EAE1B,iBAAiB;EACjB,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;;EAE1C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,eAAe;EACf,iFAAiF;;EAEjF;;;;kFAIgF;EAChF,gGAAgG;;EAEhG,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,mCAAmC;EACnC;;mEAEiE;EACjE,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA,kCAAkC;AAClC,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,4BAA4B,EAAE,mBAAmB,EAAE;;AAE/E,2BAA2B;AAC3B;EACE,aAAa;EACb;yDACuD;EACvD,mDAAmD;AACrD;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,8BAA8B;EAC9B,wEAAwE;EACxE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC,mBAAmB,sCAAsC,EAAE,wCAAwC,EAAE;AACrG,yBAAyB,0CAA0C,EAAE,4CAA4C,EAAE;AACnH,8BAA8B,wCAAwC,EAAE;AACxE,gCAAgC,iCAAiC,EAAE;AACnE,4CAA4C,4CAA4C,EAAE,wCAAwC,EAAE;AACpI,sBAAsB,sCAAsC,EAAE;AAC9D,sDAAsD,iCAAiC,EAAE;AACzF,oBAAoB,sCAAsC,EAAE;AAC5D,0BAA0B,iDAAiD,EAAE,iCAAiC,EAAE;;AAEhH,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA,sBAAsB;AACtB;;;;;2EAK2E;AAC3E;EACE;IACE,kCAAkC;IAClC,2BAA2B;IAC3B,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,oBAAoB,gCAAgC,EAAE,2BAA2B,EAAE;AACnF,oBAAoB,gCAAgC,EAAE,2BAA2B,EAAE;AACnF,oBAAoB,+BAA+B,GAAG,0BAA0B,GAAG;AACnF,oBAAoB,6BAA6B,KAAK,wBAAwB,KAAK;AACnF,oBAAoB,6BAA6B,KAAK,2BAA2B,EAAE;AACnF,oBAAoB,gCAAgC,EAAE,sBAAsB,OAAO;;AAEnF,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,mBAAmB;AACtC;AACA,mBAAmB,eAAe,EAAE,2BAA2B,EAAE,kBAAkB,EAAE;AACrF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC7F,mBAAmB,eAAe,EAAE,eAAe,EAAE;;AAErD,mBAAmB;AACnB,uBAAuB,eAAe,EAAE;AACxC;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;AACpB;AACA,uCAAuC,kBAAkB,EAAE,+CAA+C,EAAE;AAC5G,6CAA6C,4CAA4C,EAAE;AAC3F,kDAAkD,mBAAmB,EAAE;;AAEvE,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;2EAC2E;AAC3E,oCAAoC,8BAA8B,EAAE;;AAEpE,kBAAkB,iDAAiD,EAAE;AACrE,kBAAkB,yCAAyC,EAAE;AAC7D,kBAAkB,gDAAgD,EAAE;AACpE,kBAAkB,iDAAiD,EAAE;;AAErE,wBAAwB;AACxB;EACE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,iBAAiB,eAAe,EAAE,mBAAmB,EAAE,YAAY,EAAE;;AAErE,iDAAiD;AACjD;EACE,2BAA2B;EAC3B,oDAAoD;EACpD,SAAS;EACT,eAAe;AACjB;AACA,yCAAyC,8BAA8B,EAAE;AACzE,+CAA+C,6BAA6B,EAAE;AAC9E,qDAAqD,WAAW,EAAE;AAClE;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA,mDAAmD,2BAA2B,EAAE;;AAEhF,+CAA+C;AAC/C;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;;;;;uFAMuF;AACvF;EACE,UAAU;EACV,8BAA8B;AAChC;AACA;;;;EAIE,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,WAAW,cAAc,EAAE;EAC3B,cAAc,aAAa,EAAE;EAC7B,iBAAiB,eAAe,EAAE;;EAElC;yEACuE;EACvE,sBAAsB,aAAa,EAAE;AACvC;;;AAGA;;;;;;;;;;;;+DAY+D;AAC/D;EACE,sCAAsC;AACxC;;;AAGA;;;;;;;;;;;;;;;wDAewD;AACxD;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;EACjC,mCAAmC;EACnC,uBAAuB,EAAE,6CAA6C;AACxE;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,wDAAwD,EAAE;AACnE;;AAEA;uDACuD;AACvD;EACE,4BAA4B;AAC9B;;AAEA;;;;4EAI4E;AAC5E;EACE;IACE,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;AACF;;AAEA;;;;;;;;;;kCAUkC;AAClC;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA,6EAA6E;AAC7E;EACE,MAAM;EACN,SAAS;AACX;;AAEA;wDACwD;AACxD;EACE,8BAA8B;AAChC","sourcesContent":["/* ============================================================\n   CB-CONNECT - BNCB Togo - Design System\n   Charte graphique institutionnelle CEDEAO\n   Règle 60/30/10 : 60% fonds clairs / 30% vert / 10% or\n   ============================================================ */\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');\n\n:root {\n  /* ── Vert institutionnel (PRIMARY) ── */\n  --cb-green:        #1a6b3c;\n  --cb-green-dark:   #155731;\n  --cb-green-mid:    #28804e;\n  --cb-green-light:  #3da068;\n  --cb-green-pale:   #e8f5ed;\n  --cb-green-xpale:  #f0faf4;\n\n  /* ── Marron terre (SECONDARY) ── */\n  --cb-brown:        #9b563a;\n  --cb-brown-light:  #b36b4d;\n  --cb-brown-pale:   #f5ede8;\n\n  /* ── Or africain (ACCENT – max 10%) ── */\n  --cb-gold:         #d5c93b;\n  --cb-gold-dark:    #c4b935;\n  --cb-gold-pale:    #fdfce8;\n\n  /* ── Surfaces & fonds ── */\n  --cb-bg:           #f8f9fb;\n  --cb-card:         #ffffff;\n  --cb-surface:      #f4f6f5;\n  --cb-white:        #ffffff;\n\n  /* ── Texte ── */\n  --cb-text:         #111827;\n  --cb-text-sec:     #374151;\n  --cb-text-muted:   #6b7280;\n  --cb-text-light:   #9ca3af;\n\n  /* ── Bordures ── */\n  --cb-border:       #e5e7eb;\n  --cb-border-light: #f3f4f6;\n\n  /* ── Sidebar ── */\n  --cb-sidebar-bg:   #1a6b3c;\n  --cb-sidebar-w:    250px;\n  --cb-sidebar-w-lg: 250px;\n  --cb-sidebar-w-sm: 64px;\n  --cb-navbar-bg:    #155731;\n  --cb-navbar-h:     56px;\n\n  /* ── Statuts ── */\n  --cb-success-bg:   #dcfce7;\n  --cb-success-tx:   #166534;\n  --cb-warning-bg:   #fef3c7;\n  --cb-warning-tx:   #92400e;\n  --cb-danger-bg:    #fee2e2;\n  --cb-danger-tx:    #991b1b;\n  --cb-info-bg:      #dbeafe;\n  --cb-info-tx:      #1e40af;\n\n  /* ── Notification ── */\n  --cb-notif:        #ef4444;\n\n  /* ── Ombres ── */\n  --shadow-sm:  0 1px 3px rgba(0,0,0,0.08);\n  --shadow-md:  0 4px 12px rgba(0,0,0,0.10);\n  --shadow-lg:  0 10px 28px rgba(0,0,0,0.12);\n\n  /* ── Rayons ── */\n  --radius-sm:  6px;\n  --radius-md:  10px;\n  --radius-lg:  14px;\n  --radius-xl:  20px;\n\n  /* ── Typo ── */\n  --font-main: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n\n  /* Police a chasse fixe pour ce qui est VRAIMENT du code : cle d'API, code\n     d'habilitation, identifiant technique. Surtout pas pour les montants - un\n     `font-family: monospace` nu retombe sur Courier ou Liberation Mono selon le\n     poste, ce qui donne a une somme en FCFA l'allure d'une sortie de terminal.\n     Les chiffres de l'interface restent en DM Sans, alignes par `tabular-nums`. */\n  --cb-font-mono: ui-monospace, 'SF Mono', 'DM Mono', 'JetBrains Mono', Menlo, Consolas, monospace;\n\n  /* ── Transitions ── */\n  --tr-fast: 150ms ease;\n  --tr-base: 220ms ease;\n  --tr-slow: 350ms ease;\n}\n\n/* ── Reset & base ── */\n*, *::before, *::after { box-sizing: border-box; }\n\nbody {\n  margin: 0;\n  font-family: var(--font-main);\n  font-size: 14px;\n  color: var(--cb-text);\n  background: var(--cb-bg);\n  -webkit-font-smoothing: antialiased;\n  /* Chiffres a chasse constante DANS la police de l'interface : les colonnes de\n     montants s'alignent verticalement sans recourir a une police de code. C'est\n     pose une fois sur body plutot que repete sur chaque cellule. */\n  font-variant-numeric: tabular-nums lining-nums;\n  font-feature-settings: 'tnum' 1, 'lnum' 1;\n}\n\n/* ── Scrollbar personnalisée ── */\n::-webkit-scrollbar { width: 5px; height: 5px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: rgba(0,0,0,0.15); border-radius: 10px; }\n\n/* ── Layout principal ── */\n.cb-layout {\n  display: flex;\n  /* Le bandeau d'environnement decale deja `body` : sans le retrancher ici,\n     le cadre depasse le viewport de sa hauteur exacte. */\n  min-height: calc(100vh - var(--cb-banniere-h, 0px));\n}\n\n.cb-main {\n  flex: 1;\n  margin-left: var(--cb-sidebar-w);\n  margin-top: var(--cb-navbar-h);\n  min-height: calc(100vh - var(--cb-navbar-h) - var(--cb-banniere-h, 0px));\n  background: var(--cb-bg);\n  transition: margin-left var(--tr-base);\n}\n\n.cb-content {\n  padding: 28px 32px;\n  max-width: 1600px;\n}\n\n/* ── Ant Design token overrides ── */\n.ant-btn-primary { background: var(--cb-green) !important; border-color: var(--cb-green) !important; }\n.ant-btn-primary:hover { background: var(--cb-green-mid) !important; border-color: var(--cb-green-mid) !important; }\n.ant-pagination-item-active { border-color: var(--cb-green) !important; }\n.ant-pagination-item-active a { color: var(--cb-green) !important; }\n.ant-checkbox-checked .ant-checkbox-inner { background-color: var(--cb-green) !important; border-color: var(--cb-green) !important; }\n.ant-switch-checked { background: var(--cb-green) !important; }\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn { color: var(--cb-green) !important; }\n.ant-tabs-ink-bar { background: var(--cb-green) !important; }\n.ant-menu-item-selected { background-color: var(--cb-green-pale) !important; color: var(--cb-green) !important; }\n\n/* ── Cards CB ── */\n.cb-card {\n  background: var(--cb-card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--cb-border);\n  box-shadow: var(--shadow-sm);\n  padding: 24px;\n}\n\n.cb-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  gap: 12px;\n}\n\n.cb-card-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--cb-text);\n  margin: 0;\n}\n\n/* ── Page header ── */\n/* En-tete de page a l'impression.\n   Le fond vert est une aide a l'ecran : sur papier c'est un aplat de couleur qui\n   consomme de l'encre et n'apporte rien. On retire le fond, la bordure et les\n   marges, on garde le titre - les etats statistiques s'impriment, et perdre leur\n   intitule serait pire que l'imprimer sans decor.\n   Les boutons de l'en-tete portent deja `.no-print` cote ecran appelant. */\n@media print {\n  .cb-page-header-card {\n    background: transparent !important;\n    border-radius: 0 !important;\n    padding: 0 0 8px !important;\n    margin-bottom: 12px !important;\n    border-bottom: 1px solid #d1d5db;\n  }\n}\n\n.cb-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.cb-page-header > div:first-child {\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.cb-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--cb-text);\n  margin: 0;\n}\n\n.cb-page-sub {\n  font-size: 13px;\n  color: var(--cb-text-muted);\n  margin: 4px 0 0;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n/* ── Badges statut ── */\n.cb-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: var(--radius-xl);\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.cb-badge-success { background: var(--cb-success-bg); color: var(--cb-success-tx); }\n.cb-badge-warning { background: var(--cb-warning-bg); color: var(--cb-warning-tx); }\n.cb-badge-danger  { background: var(--cb-danger-bg);  color: var(--cb-danger-tx);  }\n.cb-badge-info    { background: var(--cb-info-bg);    color: var(--cb-info-tx);    }\n.cb-badge-neutral { background: var(--cb-surface);    color: var(--cb-text-muted); }\n.cb-badge-green   { background: var(--cb-green-pale); color: var(--cb-green);      }\n\n/* ── KPI Card ── */\n.kpi-card {\n  background: var(--cb-card);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--cb-border);\n  padding: 20px;\n  cursor: pointer;\n  transition: all var(--tr-base);\n  box-shadow: var(--shadow-sm);\n}\n.kpi-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n  border-color: var(--cb-green);\n}\n.kpi-card__icon {\n  width: 44px; height: 44px;\n  border-radius: var(--radius-md);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 20px; margin-bottom: 14px;\n}\n.kpi-card__label { font-size: 13px; color: var(--cb-text-muted); margin-bottom: 4px; }\n.kpi-card__value { font-size: 28px; font-weight: 700; color: var(--cb-text); line-height: 1; }\n.kpi-card__delta { font-size: 12px; margin-top: 6px; }\n\n/* ── Table CB ── */\n.cb-table .ant-table { font-size: 13px; }\n.cb-table .ant-table-thead > tr > th {\n  background: var(--cb-surface) !important;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--cb-text-muted);\n  border-bottom: 1px solid var(--cb-border);\n  padding: 12px 16px;\n}\n.cb-table .ant-table-tbody > tr > td { padding: 12px 16px; border-bottom: 1px solid var(--cb-border-light); }\n.cb-table .ant-table-tbody > tr:hover > td { background: var(--cb-green-xpale) !important; }\n.cb-table .ant-table-tbody > tr:last-child > td { border-bottom: none; }\n\n/* ── Formulaires ── */\n.cb-form-section {\n  background: var(--cb-card);\n  border: 1px solid var(--cb-border);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  margin-bottom: 20px;\n}\n.cb-form-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--cb-green);\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--cb-border);\n}\n\n/* ── Alertes délais ── */\n/* Sinistres liés : membre le moins avancé du groupe - infobulle sur la ligne\n   porte le sens, ce fond n'est qu'un renfort visuel, pas le seul signal. */\n.liaison-membre-moins-avance > td { background: #fffbeb !important; }\n\n.delai-critique { border-left: 4px solid var(--cb-notif) !important; }\n.delai-urgent   { border-left: 4px solid #f97316 !important; }\n.delai-attention{ border-left: 4px solid var(--cb-gold) !important; }\n.delai-normal   { border-left: 4px solid var(--cb-green) !important; }\n\n/* ── Loader global ── */\n.cb-loader {\n  display: flex; align-items: center; justify-content: center;\n  min-height: 200px;\n}\n\n/* ── Empty state ── */\n.cb-empty {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--cb-text-muted);\n}\n.cb-empty-icon { font-size: 48px; margin-bottom: 12px; opacity: 0.4; }\n\n/* ── Tabs à entête vert (header de section) ── */\n.cb-tabs-green > .ant-tabs-nav {\n  background: var(--cb-green);\n  border-radius: var(--radius-lg) var(--radius-lg) 0 0;\n  margin: 0;\n  padding: 0 12px;\n}\n.cb-tabs-green > .ant-tabs-nav::before { border-bottom: none !important; }\n.cb-tabs-green > .ant-tabs-nav .ant-tabs-tab { color: rgba(255,255,255,0.75); }\n.cb-tabs-green > .ant-tabs-nav .ant-tabs-tab:hover { color: #fff; }\n.cb-tabs-green > .ant-tabs-nav .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff !important;\n  font-weight: 600;\n}\n.cb-tabs-green > .ant-tabs-nav .ant-tabs-ink-bar { background: #fff !important; }\n\n/* ── Steps (progress) en vert application ── */\n.cb-steps-green .ant-steps-item-process .ant-steps-item-icon {\n  background: var(--cb-green);\n  border-color: var(--cb-green);\n}\n.cb-steps-green .ant-steps-item-finish .ant-steps-item-icon {\n  border-color: var(--cb-green);\n  background: var(--cb-green-pale);\n}\n.cb-steps-green .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {\n  color: var(--cb-green);\n}\n.cb-steps-green .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {\n  background-color: var(--cb-green);\n}\n.cb-steps-green .ant-steps-item-process .ant-steps-item-title {\n  color: var(--cb-green) !important;\n  font-weight: 600;\n}\n\n/* ── Ancrage d'une discussion sur une ligne de dossier ──\n   La pastille ne s'efface que lorsqu'AUCUN message n'y est attaché : dans ce cas\n   elle est une affordance, et une icône permanente sur chaque ligne d'un tableau\n   dense ajouterait une colonne de bruit. Dès qu'un message existe, le composant\n   retire cette classe et la pastille reste visible - c'est alors une information.\n   `focus-within` la fait réapparaître au clavier : une affordance qui n'existe\n   qu'au survol est une affordance qui n'existe pas pour qui n'utilise pas la souris. */\n.cb-ancre-discussion {\n  opacity: 0;\n  transition: opacity 140ms ease;\n}\n.ant-table-row:hover .cb-ancre-discussion,\n.ant-table-row:focus-within .cb-ancre-discussion,\n.cb-ancre-discussion:hover,\n.cb-ancre-discussion:focus {\n  opacity: 1;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .cb-main { margin-left: 0; }\n  .cb-content { padding: 16px; }\n  .cb-page-title { font-size: 18px; }\n\n  /* Le rail latéral suppose une largeur d'écran que le mobile n'a pas : la\n     discussion y passerait devant le dossier au lieu de l'accompagner. */\n  .cb-discussion-rail { display: none; }\n}\n\n\n/* ── Bandeau d'environnement ────────────────────────────────────────────────\n   Le bandeau est en `position: fixed` : il ne pousse rien tout seul. Ce\n   decalage est pose UNE fois sur `body` plutot qu'ecran par ecran, car la\n   connexion, l'OTP, l'activation et le portail de verification n'utilisent pas\n   `Layout` et les oublier aurait laisse le bandeau recouvrir leur en-tete.\n\n   CETTE REGLE VIT ICI ET NON DANS index.css : ce dernier n'est importe par\n   AUCUN module. La regle y etait donc morte, le contenu restait colle en haut,\n   et le fil d'Ariane passait sous la NavBar qu'on venait de descendre.\n\n   `--cb-banniere-h` vaut 0px tant que le bandeau n'est pas affiche : sans\n   reponse du serveur, rien ne bouge. Les elements en `position: fixed` ne sont\n   pas concernes par ce padding et portent leur propre `top`. */\nbody {\n  padding-top: var(--cb-banniere-h, 0px);\n}\n\n\n/* ── Defilement du texte du bandeau ─────────────────────────────────────────\n   Le message defile en continu et le bandeau reste PLEIN : le texte ne doit\n   jamais attendre d'avoir fini de sortir pour que le suivant entre.\n\n   Le composant mesure une copie, en pose assez pour couvrir la largeur du\n   bandeau plus une, puis expose cette largeur dans `--cb-copie-w`. On translate\n   d'exactement UNE copie : a la fin du cycle chaque copie occupe la place de sa\n   voisine, l'image est identique et le retour a zero invisible.\n\n   LA DUREE VIENT DU COMPOSANT, pas d'ici : elle est calculee a vitesse\n   constante (pixels par seconde). Une duree fixe en CSS aurait fait ramper un\n   texte court et filer un texte long.\n\n   `flex: none` sur les copies : sans lui elles se laisseraient comprimer a la\n   largeur du bandeau, la mesure vaudrait autre chose que la largeur reelle du\n   texte, et la translation ne retomberait plus juste. */\n.cb-banniere-piste {\n  display: flex;\n  flex: none;\n  width: max-content;\n  animation-name: cb-banniere-defile;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  animation-duration: 30s; /* repli tant que la mesure n'a pas eu lieu */\n}\n\n.cb-banniere-texte {\n  flex: none;\n  white-space: nowrap;\n  padding-right: 48px;\n}\n\n@keyframes cb-banniere-defile {\n  from { transform: translateX(0); }\n  to   { transform: translateX(calc(-1 * var(--cb-copie-w, 50%))); }\n}\n\n/* Le survol suspend le defilement : un message qui bouge est penible a lire en\n   entier, et c'est le geste attendu pour le retenir. */\n.cb-banniere-piste:hover {\n  animation-play-state: paused;\n}\n\n/* MOUVEMENT REDUIT : on ARRETE, on ne ralentit pas. Un bandeau permanent qui\n   defile sans fin declenche vertiges et gene chez qui a demande moins de\n   mouvement, et ce message est affiche sur tous les ecrans, en permanence.\n   Le texte reste alors centre et tronque proprement s'il est trop long, et les\n   copies decoratives disparaissent : elles ne servaient qu'au defilement. */\n@media (prefers-reduced-motion: reduce) {\n  .cb-banniere-piste {\n    animation: none;\n    width: 100%;\n    justify-content: center;\n    overflow: hidden;\n  }\n  .cb-banniere-texte {\n    flex: 0 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    padding-right: 0;\n  }\n  .cb-banniere-texte[aria-hidden=\"true\"] {\n    display: none;\n  }\n}\n\n/* ── Tiroirs et fenetres sous le bandeau d'environnement ────────────────────\n   Le bandeau est en `position: fixed` au-dessus de tout (z-index 2000). Les\n   tiroirs d'Ant Design occupent le viewport entier depuis `top: 0` : leur\n   en-tete passait donc DESSOUS et devenait illisible.\n\n   ON DESCEND LE TIROIR PLUTOT QUE D'ABAISSER LE BANDEAU. Le faire passer sous\n   le tiroir l'aurait masque pendant une saisie, c'est-a-dire au moment precis\n   ou savoir sur quel environnement on travaille importe le plus.\n\n   `--cb-banniere-h` vaut 0px quand aucun bandeau n'est affiche : sans bandeau,\n   ces regles ne deplacent rien. */\n.ant-drawer {\n  top: var(--cb-banniere-h, 0px);\n  height: calc(100% - var(--cb-banniere-h, 0px));\n}\n\n/* Le masque suit le tiroir : laisse en place, il assombrissait le bandeau. */\n.ant-drawer .ant-drawer-mask {\n  top: 0;\n  bottom: 0;\n}\n\n/* Meme raison pour les fenetres modales hautes, qui partent du haut du\n   viewport et se retrouvaient amputees de leur titre. */\n.ant-modal-wrap {\n  top: var(--cb-banniere-h, 0px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
